import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  assetClassBenchmarkIndicesAllIds,
  assetClassBenchmarkIndicesById,
  assetClassBenchmarkIndicesSelector,
] = resourceSelectors('assetClassBenchmarkIndices');
